package cc.bluepeak.clubmanager.site.components.widgets

import androidx.compose.runtime.Composable
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.styles.Theme
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.icons.lucide.LucideArrowRight
import com.varabyte.kobweb.silk.components.icons.lucide.LucideCircleDot
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Iframe

val DemoLinkStyle = CssStyle {
    base {
        Modifier.backgroundColor(Theme.primary).padding(4.px).borderRadius {
            topLeft(Theme.shapes.medium)
            bottomRight(Theme.shapes.medium)
        }
            .transition(Transition.of("background-color", duration = ButtonVars.ColorTransitionDuration.value()))
    }
    hover {
        Modifier.backgroundColor(Theme.primary.lightened())
    }
}

@Composable
fun LiveDemo(id: String, cta: String, hint: String) {
    Column(Modifier.fillMaxWidth(), horizontalAlignment = Alignment.End) {
        Row(horizontalArrangement = Arrangement.spacedBy(1.cssRem), verticalAlignment = Alignment.CenterVertically) {
            SpanText(hint, Modifier.fontWeight(FontWeight.Light).fontSize(FontSize.Smaller))
            Row(Modifier.backgroundColor(Theme.primary).padding(4.px).borderRadius {
                topLeft(Theme.shapes.medium)
                topRight(Theme.shapes.medium)
            }, verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(4.px)) {
                LucideCircleDot(color = Theme.white)
                SpanText(Res.string.live_demo, Modifier.color(Theme.white))
            }
        }
        Box(
            Modifier.fillMaxWidth().height(30.cssRem),
            contentAlignment = Alignment.BottomEnd
        ) {
            Iframe(
                Modifier.fillMaxSize()
                    .border(1.px, LineStyle.Solid, Theme.primary)
                    .borderRadius {
                        topLeft(Theme.shapes.medium)
                        bottomLeft(Theme.shapes.medium)
                        bottomRight(Theme.shapes.medium)
                    }
                    .toAttrs {
                        attr("src", Res.link.preview(id))
                    })
            Link(Res.link.register, variant = UndecoratedLinkVariant) {
                Row(
                    DemoLinkStyle.toModifier(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(4.px)
                ) {
                    SpanText(cta, Modifier.color(Theme.white))
                    LucideArrowRight(color = Theme.white)
                }
            }
        }
    }
}